// Angular Imports
import { Component, Input, booleanAttribute, computed, inject } from '@angular/core'
import { NgTemplateOutlet } from '@angular/common'
// Angular Material Imports
import { MatMenuModule } from '@angular/material/menu'
import { MatRippleModule } from '@angular/material/core'
// Shared Imports
import { FlagCountryComponent } from '../flag-country/flag-country.component'
import { ECountry, COUNTRIES, EEnvironment, ELocalStorageKeys } from '@shared/models'
import { AuthStore } from '@shared/store'

@Component({
	selector: 'app-flag-country-button',
	standalone: true,
	imports: [NgTemplateOutlet, MatMenuModule, MatRippleModule, FlagCountryComponent],
	templateUrl: './flag-country-button.component.html',
	styleUrls: ['./flag-country-button.component.scss'],
})
export class FlagCountryButtonComponent {
	readonly #authStore = inject(AuthStore)
	readonly EEnvironment = EEnvironment

	@Input({ transform: booleanAttribute }) isFull: boolean = false

	countries: ECountry[] = COUNTRIES
	country = computed(() => this.#authStore.country())
	environment: EEnvironment = EEnvironment.dev
	isAdministrator: boolean =
		window.localStorage.getItem(ELocalStorageKeys.isAdministrator) === 'true' ? true : false

	constructor() {}

	onSelectCountry(country: ECountry) {
		this.#authStore.updateCountry({ country })
		window.location.reload()
	}
}
